export default "assets/frame-1.f7d1b2a7df40adb2.png"